module.exports = __webpack_public_path__ + "img/pic_1.585be510.png";